import React, { useState, useEffect } from 'react';
import MetaTitle from '../components/MetaTitle';
import {  useNavigate } from 'react-router-dom';
import "../assete/css/careers.css";
import Header from './Header';
import career_pic from "../assete/bannerimage/career 1.jpg";
import Footer from './Footer';
import {ViewCareerDetailsApi} from "../service/Api";
import Whatsapp from './Whatsapp';
import Scrolltop from './Scrolltop';


const Careers = () => {
    
  const [details, setDetails] = useState([]);
    
     
    useEffect(() => {
           const fetchData = async () => {
               try {
                   const response = await ViewCareerDetailsApi();
                   if (response && response.careersdetails) {
                       setDetails(response.careersdetails.reverse());
                   }
               } catch (error) {
                   console.error('Error fetching data:', error);
               }
           };
           fetchData();
       }, []);

       const firstThreeCards = details.slice(0, 3);
  const remainingCards = details.slice(3);
    
      const navigate = useNavigate();
    
      const phd_peoposal = () => {
        navigate("");
     
        
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      };


      

      
  return (
<>
 <MetaTitle title={"Careers | "} description="Find the best place to guide your research works at an affordable price. Visit Sea Sense Software Pvt. Ltd. for PhD guidance."
        keywords="PhD guidance in Marthandam |
PhD assistance in marthandam | PhD Thesis writing in marthandam | PhD paper writing in marthandam | Research paper writing in marthandam |
Research assistance in Marthandam | Research guidance in marthandam | Mat lab training in marthandam | PhD addmission | PhD Scholarships |
Research topics for PhD scholar | Research topics | Recent research topics | PhD guidance in kanyakumari |
PhD assistance in kanyakumari | PhD Thesis writing in kanyakumari | PhD paper writing in kanyakumari | Research paper writing in kanyakumari |
Research assistance in kanyakumari | Research guidance in kanyakumari | Mat lab training in kanyakumari | PhD guidance in tamilnadu |
PhD assistance in tamilnadu | PhD Thesis writing in tamilnadu | PhD paper writing in tamilnadu | Research paper writing in tamilnadu |
Research assistance in tamilnadu | Research guidance in tamilnadu | Mat lab training in tamilnadu | PhD guidance in nagercoil |
PhD assistance in nagercoil | PhD Thesis writing in nagercoil | PhD paper writing in nagercoil | Research paper writing in nagercoil |
Research assistance in nagercoil | Research guidance in nagercoil | Mat lab training in nagercoil | PhD guidance in trivandrum |
PhD assistance in trivandrum | PhD Thesis writing in trivandrum | PhD paper writing in trivandrum | Research paper writing in trivandrum |
Research assistance in trivandrum | Research guidance in trivandrum | Mat lab training in trivandrum | PhD guidance in alleppey |
PhD assistance in alleppey | PhD Thesis writing in alleppey | PhD paper writing in alleppey | Research paper writing in alleppey |
Research assistance in alleppey | Research guidance in alleppey | Mat lab training in alleppey | PhD guidance in chennai |
PhD assistance in chennai | PhD Thesis writing in chennai | PhD paper writing in chennai | Research paper writing in chennai |
Research assistance in chennai | Research guidance in chennai | Mat lab training in chennai | PhD guidance in madurai |
PhD assistance in madurai | PhD Thesis writing in madurai | PhD paper writing in madurai | Research paper writing in madurai |
Research assistance in madurai | Research guidance in madurai | Mat lab training in madurai | PhD guidance in trichy |
PhD assistance in trichy | PhD Thesis writing in trichy | PhD paper writing in trichy | Research paper writing in trichy |
Research assistance in trichy | Research guidance in trichy | Mat lab training in trichy | PhD guidance in tirunelveli |
PhD assistance in tirunelveli | PhD Thesis writing in tirunelveli | PhD paper writing in tirunelveli | Research paper writing in tirunelveli |
Research assistance in tirunelveli | Research guidance in tirunelveli | Mat lab training in tirunelveli | PhD guidance in singapore |
PhD assistance in singapore | PhD Thesis writing in singapore | PhD paper writing in singapore | Research paper writing in singapore |
Research assistance in singapore | Research guidance in singapore | Mat lab training in singapore | PhD guidance in india |
PhD assistance in india | PhD Thesis writing in india | PhD paper writing in india | Research paper writing in india |
Research assistance in india | Research guidance in india | Mat lab training in india | PhD guidance in kollam |
PhD assistance in kollam | PhD Thesis writing in kollam | PhD paper writing in kollam | Research paper writing in kollam |
Research assistance in kollam | Research guidance in kollam | Mat lab training in kollam | PhD guidance in cochin |
PhD assistance in cochin | PhD Thesis writing in cochin | PhD paper writing in cochin | Research paper writing in cochin |
Research assistance in cochin | Research guidance in cochin | Mat lab training in cochin | PhD guidance in ernakulam |
PhD assistance in ernakulam | PhD Thesis writing in ernakulam | PhD paper writing in ernakulam | Research paper writing in ernakulam |
Research assistance in ernakulam | Research guidance in ernakulam | Mat lab training in ernakulam |"/>
<Header/>
<div className='seasense_web_career_main_1'>
    <img src={career_pic} alt=""/>
   
  
        <div className="about_content" >
     <h1>Join Our Team</h1>
    <p>Grow your career with Seasense Softwares Pvt. Ltd.</p>
    </div>
         </div>

         <div className='career_main_div'>
            <div className='careers_main_div_1'>
                <h2>Current Openings</h2>
                <p>If you think you have plenty to contribute to our company and wish to join our team</p>
            </div>

  {details.length === 0 ? (
          <div className="no_data_message">
            <h3>Coming Soon...</h3>
            <p>We are updating our job listings. Stay tuned!</p>
          </div>
        ) : (
          <>
          
            <div className='career_div_main_flx'>
            {firstThreeCards.map((detail, index) => (
                <div className='career_div_main_1' key={index}>
                    <div className='career_div_main_2'>
                        <div className='career_div_add_pic'>
                            
                            <div className='pic_name_add'>
                                <h1>{detail.job_name}</h1>
                            </div>
                            <div className='card_clk_btn'>
                            <button onClick={() => {
                        phd_peoposal();
                        navigate(`/Careersdetails/${detail.id}`); 
                      }}>
                        View Details
                      </button>
                            </div>
                        </div>
                    </div>
                </div>
           ))}
         </div>
         {remainingCards.length > 0 && (
          <div className='career_div_main_flx'>
            {remainingCards.map((detail, index) => (
              <div className='career_div_main_1' key={index}>
                <div className='career_div_main_2'>
                  <div className='career_div_add_pic'>
                    <div className='pic_name_add'>
                      <h1>{detail.job_name}</h1>
                    </div>
                    <div className='card_clk_btn'>
                      <button onClick={() => {
                        phd_peoposal();
                        navigate(`/Careersdetails/${detail.id}`); 
                      }}>
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          )}
          </>
        )}
      </div>
      <Whatsapp/>
      <Scrolltop/>

         <Footer/>
</>
  )
}

export default Careers